import React, { useState } from "react";
import {
    ApiDiagnosticInfo,
    diagnosticToText,
} from "./ApiDiagnostic";

interface ApiErrorDiagnosticProps {
    diagnostic: ApiDiagnosticInfo;
    title?: string;
}

export default function ApiErrorDiagnostic({
    diagnostic,
    title = "We could not load the page",
}: ApiErrorDiagnosticProps) {
    const [copied, setCopied] = useState(false);

    const diagnosticText = diagnosticToText(diagnostic);

    const copyDiagnostic = async () => {
        try {
            await navigator.clipboard.writeText(
                diagnosticText
            );

            setCopied(true);

            setTimeout(() => {
                setCopied(false);
            }, 3000);
        } catch {
            // Fallback til ældre browsere
            const textarea =
                document.createElement("textarea");

            textarea.value = diagnosticText;
            textarea.style.position = "fixed";
            textarea.style.opacity = "0";

            document.body.appendChild(textarea);

            textarea.select();
            document.execCommand("copy");

            document.body.removeChild(textarea);

            setCopied(true);
        }
    };

    return (
        <div
            style={{
                maxWidth: 750,
                margin: "40px auto",
                padding: 24,
                borderRadius: 12,
                border: "1px solid #e0e0e0",
                background: "#fff",
                boxShadow:
                    "0 4px 20px rgba(0,0,0,0.08)",
            }}
        >
            <h2
                style={{
                    marginTop: 0,
                    marginBottom: 10,
                }}
            >
                {title}
            </h2>

            <p>
                Unfortunately, we were unable to load
                the required information.
            </p>

            <p>
                Please copy the diagnostic information
                below and send it to:
            </p>

            <p>
                <strong>
                    event@badminton.dk
                </strong>
            </p>

            <div
                style={{
                    padding: 14,
                    marginTop: 20,
                    marginBottom: 20,
                    borderRadius: 8,
                    background: "#f5f5f5",
                }}
            >
                <div>
                    <strong>Error ID:</strong>{" "}
                    {diagnostic.errorId}
                </div>

                <div>
                    <strong>Error type:</strong>{" "}
                    {diagnostic.errorType}
                </div>

                <div>
                    <strong>Browser:</strong>{" "}
                    {diagnostic.browser}
                </div>

                <div>
                    <strong>Language:</strong>{" "}
                    {diagnostic.language}
                </div>

                <div>
                    <strong>HTTP status:</strong>{" "}
                    {diagnostic.status ??
                        "No response from server"}
                </div>
            </div>

            <button
                onClick={copyDiagnostic}
                style={{
                    padding: "12px 18px",
                    borderRadius: 6,
                    border: 0,
                    cursor: "pointer",
                    fontWeight: 600,
                }}
            >
                {copied
                    ? "✓ Diagnostic information copied"
                    : "Copy diagnostic information"}
            </button>

            {copied && (
                <p
                    style={{
                        marginTop: 12,
                        fontWeight: 600,
                    }}
                >
                    The information has been copied.
                    Please send it to event@badminton.dk
                </p>
            )}

            <details
                style={{
                    marginTop: 25,
                }}
            >
                <summary
                    style={{
                        cursor: "pointer",
                    }}
                >
                    Show technical information
                </summary>

                <pre
                    style={{
                        marginTop: 15,
                        padding: 15,
                        overflowX: "auto",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        background: "#f5f5f5",
                        borderRadius: 6,
                        fontSize: 12,
                    }}
                >
                    {diagnosticText}
                </pre>
            </details>
        </div>
    );
}